import { RecipeResponse } from '@/types';
import { apiClient } from './api';

export const favoriteService = {
    // Obtener recetas favoritas del usuario
    async getFavorites(token: string): Promise<RecipeResponse[]> {
        return apiClient.get('/favorites', token);
    },

    // Agregar receta a favoritos
    async addToFavorites(recipeId: number, token: string): Promise<string> {
        return apiClient.post(`/favorites/${recipeId}`, {}, token);
    },

    // Eliminar receta de favoritos
    async removeFromFavorites(recipeId: number, token: string): Promise<boolean> {
        return apiClient.delete(`/favorites/${recipeId}`, token);
    },

    // Verificar si una receta es favorita
    async isRecipeFavorite(recipeId: number, token?: string): Promise<boolean> {
        if (!token) return false;
        return apiClient.get(`/favorites/${recipeId}/status`, token);
    },

    // Obtener IDs de recetas favoritas
    async getFavoriteIds(token: string): Promise<number[]> {
        return apiClient.get('/favorites/ids', token);
    }
};